import USGSOverlay from './USGSOverlay';
import axios from 'axios';

import config from '../config';

export const getMapWithUSGSOOverlay = (lat: number, lng: number, mapTypeId: string) => () => {
    const mapElement = document.getElementById('map-wrap');
    const map = new google.maps.Map(mapElement, {
        zoom: 11,
        center: { lat, lng },
        mapTypeId,
    });

    var srcImage = 'https://s.ftcdn.net/v2013/pics/all/curated/RKyaEDwp8J7JKeZWQPuOVWvkUjGQfpCx_cover_580.jpg?r=1a0fc22192d0c808b8bb2b9bcfbf4a45b1793687';
    const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(62.281819, -150.287132),
        new google.maps.LatLng(62.400471, -150.005608));
    new USGSOverlay(bounds, srcImage, map);

    return map;
};

export const setupMap = (coordinates: any): google.maps.Map<HTMLElement> => {
    const mapElement = document.getElementById('map-wrap');
    return new google.maps.Map(mapElement, {
        zoom: coordinates.zoom || config.map.baseZoom,
        center: { lat: coordinates.lat, lng: coordinates.lng },
        mapTypeId: config.map.baseMapType,
        mapTypeControl: config.map.mapTypeControl,
    });
}

export const setupCoordinates = (map: google.maps.Map<HTMLElement>,coordinates: any) => {
    const point = new google.maps.LatLng(coordinates.lat, coordinates.lng);
    map.setCenter(point);
    map.setZoom(coordinates.zoom)
}

export const setupMarkers = (map: google.maps.Map<HTMLElement>, markers: any[]): void => {
    if (markers && markers.length > 0) {
        markers.map((marker: any) => {
            const mainMarker = new google.maps.Marker({
                position: { lat: marker.lat, lng: marker.lng },
                map,
                title: marker.label || '',
            });
            if (marker.contentString) {
                mainMarker.addListener('click', (event: any) => {
                    const infoWindow = new google.maps.InfoWindow({
                        content: marker.contentString,
                    });
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map);
                });
            }
            
        });
    }
}

export const setupImageTyles = (map: google.maps.Map<HTMLElement>): void => {
    const imageMapType = new google.maps.ImageMapType({
        getTileUrl: (coord, zoom) => {
            return `https://cdn.scitani2021.algorim.dev/mapdata/tiles/${zoom}/${coord.y}/${coord.x}.png`;
        },
        tileSize: new google.maps.Size(256, 256),
    });
    map.overlayMapTypes.push(imageMapType);
}

export const setupPolyline = (map: google.maps.Map<HTMLElement>): void => {
    const coords = [
        { lat: 50.108, lng: 14.27 },
        { lat: 50.10801207101181, lng: 14.269973903730584 },
        { lat: 50.10799660170225, lng: 14.440149173701853 },
        { lat: 50.108, lng: 14.44 },
    ];
    const path = new google.maps.Polyline({
        path: coords,
        geodesic: config.polyline.geodesic,
        strokeColor: config.polyline.strokeColor,
        strokeOpacity: config.polyline.strokeOpacity,
        strokeWeight: config.polyline.strokeWeight,
    });
    path.setMap(map);
}

export const getMapWithTyles = (coordinates: any, markers: any[]) => () => {
    const map = setupMap(coordinates);
    setupMarkers(map, markers);

    setupImageTyles(map);

    setupPolyline(map);
}

export const setupDirection = (map: google.maps.Map<HTMLElement>, startCoord: google.maps.LatLng, endCoord: google.maps.LatLng) => {
    const directionsService = new google.maps.DirectionsService();
    const request = {
        origin: startCoord,
        destination: endCoord,
        travelMode: google.maps.TravelMode.DRIVING
    };
    directionsService.route(request, (response, status) => {
        const directionsDisplay = new google.maps.DirectionsRenderer();
        if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
            directionsDisplay.setMap(map);
        }
    });
}

export const setupPlace = (placeId: string, map: google.maps.Map<HTMLElement>) => {
    const request = {
        placeId,
        fields: ['geometry'],
    };
    const service = new google.maps.places.PlacesService(map);
    service.getDetails(request, (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            new google.maps.Marker({
                position: result.geometry.location,
                map,
                title: '',
            });
            map.setCenter(result.geometry.location);
        }
    });
}

export const getCurrentPosition = (map: google.maps.Map<HTMLElement>) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
            new google.maps.Marker({
                position: { lat: Number(position.coords.latitude), lng: Number(position.coords.longitude) },
                map,
                title: 'MOJE AKTUALNI POZICE',
            });
            map.setCenter(new google.maps.LatLng(Number(position.coords.latitude), Number(position.coords.longitude)));
        });
    }
}

